import { useSuspenseQuery } from "@tanstack/react-query";
import { type WojoAccountConfig } from "@wojo/storyblok";
import { getAccountConfig } from "./get-account-config";

export const useAccountConfigSuspenseQuery = (): WojoAccountConfig => {
    const { data } = useSuspenseQuery({
        refetchOnReconnect: false,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        queryKey: ["configurations/account"],
        queryFn: getAccountConfig,
    });

    return data;
};
